export enum LocalStorageKey {
  AI_LISTENING_LAST_PROFILE = 'aiListeningLastProfile',
  ANONYMOUS_ID = 'anonymousId',
  BANNER_STATE = 'bannerState',
  DATE_FILTER_PERIOD = 'dateFilterPeriod',
  INTERNAL_TESTER = 'internal_tester',
  LAST_ACTIVE_INDEX = 'lastActiveIndex',
  SESSION_ID = 'session_id',
}
